/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { PostOfficeWithdrawalRequest } from '../model/postOfficeWithdrawalRequest';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Post office withdrawal
 */
export const usePostOfficeWithdrawalHook = () => {
  const postOfficeWithdrawal = useCustomClient<void>();

  return (
    postOfficeWithdrawalRequest: BodyType<PostOfficeWithdrawalRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return postOfficeWithdrawal(
      {
        url: `/api/js/office_withdrawal`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postOfficeWithdrawalRequest,
      },
      options
    );
  };
};

export const usePostOfficeWithdrawalMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostOfficeWithdrawalHook>>>,
    TError,
    { data: BodyType<PostOfficeWithdrawalRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePostOfficeWithdrawalHook>>>,
  TError,
  { data: BodyType<PostOfficeWithdrawalRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const postOfficeWithdrawal = usePostOfficeWithdrawalHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePostOfficeWithdrawalHook>>>,
    { data: BodyType<PostOfficeWithdrawalRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postOfficeWithdrawal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOfficeWithdrawalMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePostOfficeWithdrawalHook>>>
>;
export type PostOfficeWithdrawalMutationBody =
  BodyType<PostOfficeWithdrawalRequest>;
export type PostOfficeWithdrawalMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Post office withdrawal
 */
export const usePostOfficeWithdrawal = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostOfficeWithdrawalHook>>>,
    TError,
    { data: BodyType<PostOfficeWithdrawalRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = usePostOfficeWithdrawalMutationOptions(options);

  return useMutation(mutationOptions);
};
